<div class="thank-you">
  <div class="thank-you__card">
    <div class="thank-you__title">
      {{ "missingVehicleInfo.thankYouTitle" | translate }}
    </div>
    <div class="thank-you__desc">
      {{ "missingVehicleInfo.thankYouDesc" | translate }}
    </div>
    <button type="button" mat-flat-button class="thank-you__btn" mat-dialog-close>
      {{ "missingVehicleInfo.close" | translate }}
    </button>
  </div>
</div>
